export default __webpack_public_path__ + "static/media/Gilroy-Extrabold.5c5942d3.woff2";